export function readDocumentCssPx(varName: string, fallback = 0) {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim();
  const px = Number.parseInt(raw, 10);

  return Number.isFinite(px) ? px : fallback;
}
